import {
  Footprints,
  PersonStanding,
  Bike,
  Car,
  Bus,
  TramFront,
  Plane,
  Ship,
  Compass,
  type LucideIcon,
} from 'lucide-preact';
import { t } from '../i18n';

/**
 * Transport modes per arrivesafe-api issue #133. `detecting` is the
 * placeholder while the mobile client's auto-detection hasn't yet locked.
 */
export type TransportType =
  | 'foot'
  | 'running'
  | 'bike'
  | 'car'
  | 'motorcycle'
  | 'bus'
  | 'train'
  | 'plane'
  | 'boat'
  | 'horse'
  | 'detecting';

const ICONS: Record<TransportType, LucideIcon> = {
  foot: Footprints,
  running: PersonStanding,
  bike: Bike,
  car: Car,
  motorcycle: Bike, // lucide has no Motorcycle; visually close enough at chip size
  bus: Bus,
  train: TramFront,
  plane: Plane,
  boat: Ship,
  horse: Compass, // lucide has no Horse — Compass reads as "less common mode" without being misleading
  detecting: Compass,
};

export function transportIcon(type: TransportType): LucideIcon {
  return ICONS[type];
}

export function transportLabel(type: TransportType): string {
  return t(`transport.${type}` as const);
}

export function isKnownTransport(value: unknown): value is TransportType {
  return typeof value === 'string' && value in ICONS;
}
